"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManufacturerFeedEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const ManufacturerFeedDto_1 = require("./ManufacturerFeedDto");
const ManufacturerDto_1 = require("../manufacturers/ManufacturerDto");
const ManufacturerEntity_1 = require("../manufacturers/ManufacturerEntity");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class ManufacturerFeedEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, manufacturerFeed) {
        super();
        this._requiredFieldsSetStatus = {
            manufacturerId: false,
            site: false,
            url: false
        };
        this._dependencies = dependencies;
        if (manufacturerFeed === undefined) {
            this._dto = new ManufacturerFeedDto_1.ManufacturerFeedDto();
        }
        else if (manufacturerFeed instanceof ManufacturerFeedDto_1.ManufacturerFeedDto) {
            this._dto = new ManufacturerFeedDto_1.ManufacturerFeedDto(manufacturerFeed);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (manufacturerFeed instanceof ManufacturerFeedEntity) {
            this._dto = new ManufacturerFeedDto_1.ManufacturerFeedDto(manufacturerFeed._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new ManufacturerFeedDto_1.ManufacturerFeedDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getManufacturer() {
        if (this._dto.manufacturerId === undefined) {
            return undefined;
        }
        if (this._dto.manufacturer === undefined) {
            throw new Error("Cannot call getManufacturer without first loading the Manufacturer.");
        }
        if (!this._manufacturerEntity && this._dto.manufacturer) {
            this._manufacturerEntity = new ManufacturerEntity_1.ManufacturerEntity(this._dependencies, this._dto.manufacturer);
        }
        return this._manufacturerEntity;
    }
    setManufacturer(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof ManufacturerEntity_1.ManufacturerEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof ManufacturerDto_1.ManufacturerDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setManufacturerId(untrustedId);
        if (this.hasError("manufacturerId")) {
            return;
        }
        if (untrustedValue instanceof ManufacturerEntity_1.ManufacturerEntity) {
            this._manufacturerEntity = untrustedValue;
        }
    }
    getManufacturerId() {
        return this._dto.manufacturerId;
    }
    setManufacturerId(untrustedValue) {
        let _untrustedValue;
        this.clearError("manufacturerId");
        this._requiredFieldsSetStatus.manufacturerId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("manufacturerId", "Manufacturer Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("manufacturerId", "Manufacturer is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.manufacturerId) {
            return;
        }
        this._dto.manufacturerId = _untrustedValue;
        delete this._manufacturerEntity;
        this._setIsDirty(true);
    }
    getSite() {
        return this._dto.site;
    }
    setSite(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("site");
        this._requiredFieldsSetStatus.site = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("site", "Site is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("site", `Site has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.site) {
            return;
        }
        this._dto.site = _untrustedValue;
        this._setIsDirty(true);
    }
    getUrl() {
        return this._dto.url;
    }
    setUrl(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("url");
        this._requiredFieldsSetStatus.url = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("url", "Url is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("url", `Url has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.url) {
            return;
        }
        this._dto.url = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadManufacturerAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getManufacturerId()) {
                    return;
                }
                this._emit("before-loadManufacturerAsync");
                this._dto.manufacturer = yield this._dependencies.manufacturerDatastore
                    .getAsync(this.getManufacturerId());
                delete this._manufacturerEntity;
                this._emit("after-loadManufacturerAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.manufacturerFeedDatastore
                    .getAsync(id, expand);
                delete this._manufacturerEntity;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Manufacturer Feeds is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.manufacturerFeedDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.manufacturerFeedDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Manufacturer Feeds cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.manufacturerFeedDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.ManufacturerFeedEntity = ManufacturerFeedEntity;
//# sourceMappingURL=ManufacturerFeedEntity.js.map